var map = {
	"./account.svg": "19a8",
	"./address-book.svg": "62c3",
	"./atm.svg": "237b",
	"./cash.svg": "dc18",
	"./chailease.png": "f192",
	"./chart-bar.svg": "560c",
	"./clipboard-list.svg": "2c67",
	"./cog.svg": "6e2a",
	"./credit-card.svg": "3840",
	"./daycare.svg": "8910",
	"./dollar-sign.svg": "284d",
	"./face-cream.svg": "8041",
	"./hotel.svg": "3bf5",
	"./line-pay.png": "5e14",
	"./online-credit-card.svg": "534d",
	"./piggy-bank.svg": "a17b",
	"./scissors.svg": "da3d",
	"./screen-users.svg": "3717",
	"./service-icon.svg": "8a61",
	"./store-alt.svg": "8f601",
	"./ticket.svg": "b9f2",
	"./user-clock.svg": "7e08",
	"./users-class.svg": "7cac"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "0075";